import { Building2, CalendarClock, CreditCard, Landmark, LayoutDashboard, Mail, Plug, UserCircle, Users, Wallet, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Two keys pressed in sequence: g then this. */
  hotkey?: string;
}

export interface NavSection { title: string; items: NavItem[] }

export const NAV: NavSection[] = [
  { title: 'Платформа', items: [
    { to: '/',              label: 'Обзор',            icon: LayoutDashboard, hotkey: 'o' },
    { to: '/channex',       label: 'Интеграция Channex', icon: Plug,          hotkey: 'i' },
  ] },
  { title: 'Клиенты', items: [
    { to: '/organizations', label: 'Организации',      icon: Landmark,  hotkey: 'r' },
    { to: '/hotels',        label: 'Отели',            icon: Building2, hotkey: 'h' },
    { to: '/users',         label: 'Пользователи',     icon: Users,     hotkey: 'u' },
  ] },
  { title: 'Деньги', items: [
    { to: '/plans',         label: 'Тарифы',           icon: CreditCard, hotkey: 'p' },
    { to: '/subscriptions', label: 'Подписки',         icon: CalendarClock, hotkey: 's' },
    { to: '/channex-cost',  label: 'Channex: расходы', icon: Wallet,     hotkey: 'c' },
  ] },
  { title: 'Коммуникации', items: [
    { to: '/email-templates', label: 'Письма',         icon: Mail,       hotkey: 'e' },
  ] },
  { title: 'Аккаунт', items: [
    { to: '/account',       label: 'Профиль и сессии', icon: UserCircle, hotkey: 'a' },
  ] },
];

export const NAV_FLAT: NavItem[] = NAV.flatMap((s) => s.items);
